"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchVoices;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _SpeechSynthesisVoice = _interopRequireDefault(require("./SpeechSynthesisVoice"));
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, -1] }] */


function fetchVoices(_x) {
  return _fetchVoices.apply(this, arguments);
}

function _fetchVoices() {
  _fetchVoices = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var authorizationToken, region, res, voices;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authorizationToken = _ref.authorizationToken, region = _ref.region;
            _context.next = 3;
            return fetch("https://".concat(encodeURI(region), ".tts.speech.microsoft.com/cognitiveservices/voices/list"), {
              headers: {
                authorization: "Bearer ".concat(authorizationToken),
                'content-type': 'application/json'
              }
            });

          case 3:
            res = _context.sent;

            if (res.ok) {
              _context.next = 6;
              break;
            }

            throw new Error('Failed to fetch voices');

          case 6:
            _context.next = 8;
            return res.json();

          case 8:
            voices = _context.sent;
            return _context.abrupt("return", voices.map(function (_ref2) {
              var gender = _ref2.Gender,
                  lang = _ref2.Locale,
                  voiceURI = _ref2.Name;
              return new _SpeechSynthesisVoice.default({
                gender: gender,
                lang: lang,
                voiceURI: voiceURI
              });
            }).sort(function (_ref3, _ref4) {
              var x = _ref3.name;
              var y = _ref4.name;
              return x > y ? 1 : x < y ? -1 : 0;
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchVoices.apply(this, arguments);
}